import { Children } from "react";

export type SectionPropType = {
    isContainer? : boolean,
    className? : string,
    children? : JSX.Element[] | JSX.Element
}

const Section = ({
        className = '', 
        isContainer = true, 
        children
    }:SectionPropType)=>{
    return (
        <section className={"w-full py-3 " + (isContainer && ' container mx-auto ') + className}>
            {children}
        </section>
    )
}

export default Section;